import { useLanguageStore } from "../stores/useLanguageStore";
import { t } from "./translations";

export const useTranslate = () => {
  const language = useLanguageStore((state) => state.language);
  return (key, params) => t(language, key, params);
};
